

class incrediantsSwiper extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-swiper-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');     
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');
        this.dotts = this.querySelector('.swiper-pagination');
        this.large = this.slider.getAttribute('data-large');
        this.medium = this.slider.getAttribute('data-medium');
        this.small = this.slider.getAttribute('data-small');
        this.enableSliderLooping = false;
        this.autoplaySpeed = this.slider.dataset.speed * 1000;      
        if (this.slider.getAttribute('data-autoplay') === 'true') {
            this.enableSliderLooping = true;
             this.autoplayParm = {
                autoplay: {
                    delay: this.autoplaySpeed,
                },
            };
        } else {
            this.autoplayParm = {};
          if (this.slider.getAttribute('data-loop') === 'true') {
            this.enableSliderLooping = true;
          }
        }

      if (!this.slider) return;
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);        
        this.initPages();
    }
    initPages() {
        let swiperParms = {
             ...this.autoplayParm,
            slidesPerView: this.large,
            spaceBetween: 20,
            loop: this.enableSliderLooping,
             autoplay: {
              delay: 3000,
              },
              speed: 900,
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            },
           pagination: {
        el: this.dotts,
        clickable: true,
      },
            breakpoints: {
                320: {
                    slidesPerView: this.small,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: this.medium,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: this.large,
                    spaceBetween: 50,
                },
            },            
        };
        this.mySwiper = new Swiper(this.slider, swiperParms);
      console.log(swiperParms);
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }
}
customElements.define('incrediants-slider', incrediantsSwiper);